import {ThunkDispatch, UnknownAction} from '@reduxjs/toolkit';
import {showNotification} from 'platform/components';

import {isNotNil} from 'ramda';

import i18n from '@dms/i18n';

import {messagingApi} from '../..';
import {AppSyncDataPayload, SubscribeToNotificationsApiArg} from '../types';
import {fetchBackgroundNotificationWithRetry} from './fetchBackgroundNotificationWithRetry';

export const handleIncomingData =
  (
    dispatch: ThunkDispatch<any, any, UnknownAction>, // eslint-disable-line typescript/no-explicit-any -- Pre-existing any
    onData: (notification: SubscribeToNotificationsApiArg) => void
  ) =>
  (payload: AppSyncDataPayload) => {
    const backgroundNotificationId = payload.data.onSendNotification.backgroundNotificationId;
    const toastNotificationId = payload.data.onSendNotification.toastNotificationId;

    if (isNotNil(backgroundNotificationId)) {
      fetchBackgroundNotificationWithRetry(() =>
        dispatch(
          messagingApi.endpoints.getSentBackgroundNotification.initiate({
            id: backgroundNotificationId,
          })
        ).unwrap()
      ).then((data) => {
        if (isNotNil(data)) {
          onData({variant: 'background', ...data});
        } else {
          showNotification.error();
        }
      });
    }

    if (isNotNil(toastNotificationId)) {
      dispatch(
        messagingApi.endpoints.getSentToastNotification.initiate({
          id: toastNotificationId,
        })
      )
        .unwrap()
        .then((data) => {
          showNotification.info(i18n.t('general.labels.newNotificationReceived'));
          onData({variant: 'toast', ...data});
        })
        .catch(() => {
          showNotification.error();
        });
    }
  };
